
export default {
    /** 共通 **/
    redirectCheck (state, data) {
        if (data.code == 403) {location.href= data.to} 
    },

    /** 応募一覧画面 **/
   // setAppPostCnt (state, data) {
   //     let proc = data.proc
   //     let proj_id = data.id
   //     let app = state.applies.data.data.find((item)=>item.proj_id == proj_id)
   //     if (proc == 'DocOK') {
   //         app.apply_cnt_unopen--
   //         app.apply_cnt_opened++
   //         app.intv_cnt++
   //     }
   //     if (proc == 'DocNG') {
   //         app.apply_cnt_unopen--
   //         app.apply_cnt_opened++
   //     }
   //     if (proc == 'IntvOK' || proc == 'IntvNG') {
   //         app.intv_cnt--
   //     }
   //     
   // },

    /** 応募状況画面 **/
    setApplyStatusDetail (state, data) {
        state.applyStatusDetail = data
    },
    setApplyStatusDetailLoadStatus (state, status) {
        state.applyStatusDetailLoadStatus = status
    },
    resetApplyStatusDetail (state) {
        state.applyStatusDetail = {}
        state.applyStatusDetailLoadStatus = 0
    },
    updateApplyStatusDetail (state, resp) {
        state.applyStatusDetail.appStatus = resp.data
    },
    setSaveApplyStatusDetailStatus (state, status) {
        state.saveApplyStatusDetailStatus = status
    },
    updateApplyTech (state, resp) {
        state.applyStatusDetail.tech = resp.data
    },
    setSaveApplyTechStatus (state, status) {
        state.saveApplyTechStatus = status
    },

    /** 契約書画面 **/
    setContractOperat (state, operat) {
        if (operat == 'success') {
            state.contractOperat = 'show'
        } else {
            state.contractOperat = operat == 'create_confirm' ? 'create' : 'edit'
        }
    },
    resetContractOperat (state) {
        state.contractOperat = ""
    },
    setSaveContractInfoStatus (state, status) {
        state.saveContractInfoStatus = status
    },
    setContractInfo (state, resp) {
        state.contractInfo = resp
    },
    setContractInfoLoadStatus (state, status) {
        state.contractInfoLoadStatus = status
    },




    /** 応募詳細画面 **/

    setAppDetail (state, appDetail) {
        state.appDetail = appDetail
    },
    resetAppDetail (state) {
        state.appDetail = {}
        state.appDetailLoadStatus = 0
    },
    setAppDetailLoadStatus (state, status) {
        state.appDetailLoadStatus = status
    },

    //setAppPricePubliced (state, resp) {
    //    let app = state.appDetail.data.techs.find((item)=>item.ai_id == resp.data.id)
    //    app.price_pub = resp.data.price_pub
    //    app.price_pub_start = resp.data.price_pub_start
    //    app.price_pub_end = resp.data.price_pub_end
    //},

    setAppPricePubStatus (state, status) {
        state.appPricePubStatus = status
    },

    setAppNamePubStatus (state, status) {
        state.appNamePubStatus = status
    },

    setApprovalApplyStatus (state, status) {
        state.approvalApplyStatus = status
    },

    setEnterConfirmStatus (state, status) {
        state.enterConfirmStatus = status
    },

    setCancelIntvStatus (state, status) {
        state.cancelIntvStatus = status
    },

    /** 契約期間 **/
    setContractPeriodSaveStatus (state, status) {
        state.contractPeriodSaveStatus = status
    },

    /** 現場中など**/
    setWorkStatus (state, resp) {
        state.workStatus = resp
    },
    setWorkStatusSelected (state, data) {
        state.workStatusSelected = data
    },
    resetWorkStatusSelected (state) {
        state.workStatusSelected = []
    },
    setWorkStatusLoadStatus (state, status) {
        state.workStatusLoadStatus = status
    },
    resetWorkStatus (state) {
        state.workStatus = {},
        state.workStatusLoadStatus = 0
    },
    updateWorkToList (state, data) {
        let intv_id = data.id
        let idx = state.workStatus.data.findIndex((item)=>item.id == intv_id)
        if (idx != -1) {
            let obj = state.workStatus.data[idx]
            let combin = Object.assign({}, obj, data)
            state.workStatus.data.splice(idx, 1, combin)
        }
    },
    updateWorkToSelectList (state, data) {
        let intv_id = data.id
        let idx = state.workStatusSelected.findIndex((item)=>item.id == intv_id)
        if (idx != -1) {
            let obj = state.workStatusSelected[idx]
            let combin = Object.assign({}, obj, data)
            state.workStatusSelected.splice(idx, 1, combin)
        }
    },

    /** 退場確定 **/
    setExitConfirmSaveStatus (state, status) {
        state.exitConfirmSaveStatus = status
    },
    /** 退場済みに変更 **/
    setChangeToExitedStatus (state, status) {
        state.changeToExitedStatus = status
    },

    setNewApplyPost (state, resp) {
        state.newApplyPost = resp
    },
    setAddedInterview (state, interview) {
        state.addedInterview = interview
    },
    setAddInterviewStatus (state, status) {
        state.addInterviewStatus = status
    },
    setAddedEntrance (state, entrance) {
        state.addedEntrance = entrance
    },
    setAddedEntranceToIntv (state, entrance) {
        state.addedInterview.inputPlace = entrance.inputPlace
        state.addedInterview.inputName = entrance.inputName
        state.addedInterview.inputPhone = entrance.inputPhone
    },
    setAddNoteStatus (state, status) {
        state.addNoteStatus = status
    },
    setSendMailDocNGStatus (state, status) {
        state.sendMailDocNGStatus = status
    },
    setSendMailIntvNGStatus (state, status) {
        state.sendMailIntvNGStatus = status
    },
    setSendMailIntvOKStatus (state, status) {
        state.sendMailIntvOKStatus = status
    },
    setSendMailIntvOKWithNextStatus (state, status) {
        state.sendMailIntvOKWithNextStatus = status
    },

    // 入場予定詳細
    setEnterDetail (state, resp) {
        state.enterDetail = resp
    },
    resetEnterDetail (state) {
        state.enterDetail = {}
        state.enterDetailLoadStatus = 0
    },
    setEnterDetailLoadStatus (state, status) {
        state.enterDetailLoadStatus = status
    },


}
